class WLSYouTubeVideo {
    constructor(element) {
        this.element = element;
        this.youtubeId = this.element.dataset.youtubeId;
        
        /**
         * CSS classes used by the component
         */
        this.classes = {
            active: 'active',
            trigger: 'js-wls-youtube-video-trigger',
            iframe: 'js-wls-youtube-video-iframe'
        };

        /**
         * Store references to DOM elements
         */
        this.elements = {
            trigger: this.element.querySelector(`.${this.classes.trigger}`),
            iframe: this.element.querySelector(`.${this.classes.iframe}`)
        };

        /**
         * YouTube player instance
         */
        this.player = null;
        this.isInitialized = false;

        this.bindEvents();
    }

    /**
     * Initialize the YouTube player
     */
    initYouTubePlayer() {
        if (this.isInitialized) return;

        this.player = new YT.Player(`player-${this.youtubeId}`, {
            videoId: this.youtubeId,
            playerVars: {
                autoplay: 0,
                controls: 1,
                rel: 0,
                showinfo: 0,
                modestbranding: 1,
                playsinline: 1
            },
            events: {
                onReady: () => {
                    this.isInitialized = true;
                }
            }
        });
    }

    /**
     * Bind events to the component
     */
    bindEvents() {
        this.elements.trigger?.addEventListener('click', () => this.play());
    }

    /**
     * Play the video
     */
    play() {
        if (this.player && typeof this.player.playVideo === 'function') {
            this.player.playVideo();
            this.element.classList.add(this.classes.active);
        }
    }
}

/**
 * Initialize YouTube API and videos
 */
const initYouTubeVideos = () => {
    const videos = document.querySelectorAll('.wls-youtube-video');
    if (!videos.length) return;

    /**
     * Load YouTube API if not already loaded
     */
    if (!window.YT) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        /**
         * Set up global callback for when API is ready
         */
        window.onYouTubeIframeAPIReady = () => {
            videos.forEach(video => {
                const ytVideo = new WLSYouTubeVideo(video);
                ytVideo.initYouTubePlayer();
            });
        };
    } else if (window.YT && window.YT.Player) {
        videos.forEach(video => {
            const ytVideo = new WLSYouTubeVideo(video);
            ytVideo.initYouTubePlayer();
        });
    }
};

/**
 * Initialize on page load
 */
document.addEventListener('DOMContentLoaded', initYouTubeVideos);

/**
 * Re-initialize when Shopify section is reloaded
 */
document.addEventListener('shopify:section:load', initYouTubeVideos); 